<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold d-flex adding-sm align-items-center text-sm justify-content-between catalogo-text"
          >
            Registrar Perfil
            <router-link :to="{ name: 'perfiles' }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="12">
                <CRow>
                  <CCol sm="9">
                    <CInput
                      :value.sync="$v.nombrePerfil.$model"
                      :isValid="checkIfValid('nombrePerfil')"
                      label="Nombre del perfil:"
                      placeholder="Nombre..."
                      invalidFeedback="Campo requerido, debe tener al menos 3 caracteres y maximo 25 caracteres"
                    />
                  </CCol>
                </CRow>
                <hr class="my-4 line" />
                <CDataTable
                  hover
                  sorter
                  bordered
                  small
                  fixed
                  :items="itemsModal"
                  :fields="fieldsModal"
                >
                  <template #credencial="{item, index}">
                    <td class="h4">
                      {{ item.credencial }}
                    </td>
                  </template>

                  <template #details="{item:categoria}">
                    <!-- <CCollapse :show="details.includes(index)"> -->
                    <!-- <CCardBody> -->
                    <CDataTable
                      class="mx-3"
                      v-if="categoria.credenciales.length > 0"
                      :items="categoria.credenciales"
                      :fields="fieldsSub"
                      :header="false"
                    >
                      <!-- <template #name="{item}">
                        <td class="py-2 px-1">
                          {{ item.id }}
                          {{ item.name }}
                        </td>
                      </template> -->
                      <template #switch="{item, index}">
                        <td
                          class="py-2 d-flex align-items-center justify-content-end"
                        >
                          <CSwitch
                            v-if="
                              item.id !== 1 ||
                                categoria.credencial !== 'Reportes'
                            "
                            @update:checked="addItem(item, index)"
                            color="primary"
                            :checked="item.value"
                            variant="3d"
                          />
                          <CSwitch
                            v-else
                            @update:checked="checkAllReports(item, index)"
                            color="success"
                            :checked="item.value"
                            variant="3d"
                          />
                        </td>
                      </template>
                    </CDataTable>
                    <!-- </CCardBody> -->
                    <!-- </CCollapse> -->
                  </template>
                </CDataTable>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="9" md="9" lg="9">
                <CAlert
                  fade
                  color="success"
                  class="my-1"
                  :show.sync="currentAlertCounter"
                  >Guardado con éxito.</CAlert
                >
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'perfiles' }">
              <CButton class="px-4 mx-3 btn-lg" color="danger"
                >Cancelar</CButton
              >
            </router-link>

            <CButton
              @click="addPerfil()"
              class="px-4 mx-3 btn-lg"
              color="success"
            >
              <div v-if="isLoading">
                <div
                  class="w-100 d-flex justify-content-center align-items-center"
                >
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
              <span v-else>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>

      <CModal
        size="sm"
        title="Perfil"
        :centered="true"
        color="warning"
        :show.sync="warningModal"
        >{{ error }}</CModal
      >
    </CRow>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

import mixinPerfil from "@/mixins/Perfil.js";

export default {
  name: "NuevoPerfil",
  data() {
    return {
      currentAlertCounter: 0
    };
  },

  mixins: [validationMixin, mixinPerfil],
  validations: {
    nombrePerfil: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(25)
    }
  },

  computed: {
    isValidPerfil() {
      return !this.$v.nombrePerfil.$invalid;
    }
  },

  created() {
    this.getCredenciales();
  },

  methods: {
    addPerfil() {
      debugger
      this.validatePerfil();

      if (this.isValidPerfil) {
        this.isLoading = true;

        let newCredenciales = [];
        this.credenciales.map(item => {
          Array.isArray(item)
            ? newCredenciales.push(...item)
            : newCredenciales.push(item);
        });

        // if(this.nombrePerfil == "Administrador") {
        // newCredenciales.push("")
        // }

        this.$store
          .dispatch("customRolActHTTP", {
            rol: this.nombrePerfil,
            credenciales: newCredenciales
          })
          .then(() => {
            // console.log(res.data);
            this.currentAlertCounter = 6;
            // this.$router.push({ name: "perfiles" });
          })
          .catch(rej => {
            // console.log(rej);
            this.error = rej.message;
            this.warningModal = true;
          })

          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validatePerfil() {
      this.$v.nombrePerfil.$touch();
      // this.$v.equivalencia_6oz.$touch();
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
